export const MENU_HEIGHT = 52
export const ITEM_SPY_OFFSET = 52
